var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.666 3.5C5.136 3.5 3.5 5.233 3.5 7.916V16.084C3.5 18.767 5.136 20.5 7.666 20.5H16.335C18.865 20.5 20.5 18.767 20.5 16.084V7.916C20.5 5.233 18.865 3.5 16.335 3.5H7.666ZM16.335 22H7.666C4.277 22 2 19.622 2 16.084V7.916C2 4.378 4.277 2 7.666 2H16.335C19.724 2 22 4.378 22 7.916V16.084C22 19.622 19.724 22 16.335 22Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.8358C11.586 16.8358 11.25 16.4998 11.25 16.0858V7.91382C11.25 7.49982 11.586 7.16382 12 7.16382C12.414 7.16382 12.75 7.49982 12.75 7.91382V16.0858C12.75 16.4998 12.414 16.8358 12 16.8358Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 16.837C11.8012 16.837 11.6092 16.758 11.4692 16.616L7.72119 12.852C7.42819 12.558 7.43019 12.083 7.72319 11.791C8.01719 11.5 8.49119 11.498 8.78319 11.793L12.0002 15.024L15.2172 11.793C15.5102 11.498 15.9842 11.5 16.2772 11.791C16.5702 12.083 16.5722 12.558 16.2792 12.852L12.5312 16.616C12.3912 16.758 12.1992 16.837 12.0002 16.837Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownS);
export default __webpack_public_path__ + "static/media/ArrowDownS.d0ef6cbcdb3f572ada71377e04273d0f.svg";
export { ForwardRef as ReactComponent };